import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useOverviewRoute} from './use-overview-route'

export function useOverviewRouteData() {
  const overviewRoute = useOverviewRoute()
  const {data, ...rest} = useRouteQuery(overviewRoute, 'mainQuery')
  return {...data, ...rest}
}

export function useOverviewRouteQueryKey() {
  const overviewRoute = useOverviewRoute()
  return useRouteQueryKey(overviewRoute, 'mainQuery')
}
